// @flow

import React from 'react';
import { observer } from 'mobx-react';
import range from 'lodash/range';
import FontAwesome from 'react-fontawesome';
import { css } from 'glamor';

const starsRule = css({
    listStyle: 'none',
    paddingLeft: 0,
});

const starListRule = css({
    display: 'inline-block',

    '&:not(:last-child)': {
        paddingRight: '3px',
    },
});

const starRule = css({
    color: '#fff',
});

const filledStarRule = css({
    color: 'rgb(228, 65, 34)',
});

@observer
export default class Stars extends React.Component {
    props: {
        rating: number,
        maxRating: number,
    };

    render() {
        const { rating, maxRating } = this.props;
        const ratings = range(1, maxRating + 1);
        const colorRules = r =>
            r <= rating ?
            {
                style: filledStarRule,
                icon: 'star',
            } :
            {
                style: starRule,
                icon: 'star-o',
            };

        return (
            <ul { ...starsRule }>
                {ratings.map(r => (
                    <li key={ r } { ...starListRule } { ...colorRules(r).style }>
                        <FontAwesome name={ colorRules(r).icon } />
                    </li>
                ))}
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Stars/index.js